import React, { useCallback } from "react"
import Pagination from "react-js-pagination"
import "./pagination.scss"
import { StaticImage } from "gatsby-plugin-image"

const CustomPagination = (props) => {
  const {
    handlePageChange,
    activePage,
    Total,
    itemsCount,
  } = props

  const totalPages = Math.ceil(Total / itemsCount)

  const setPrevPage = useCallback(() => {
    if (activePage <= 1) {
      return
    }
    handlePageChange(activePage - 1)
  }, [activePage, handlePageChange])

  const setNextPage = useCallback(() => {
    if (activePage >= totalPages) {
      return
    }

    handlePageChange(activePage + 1)
  }, [activePage, totalPages, handlePageChange])

  const setLastPage = useCallback(() => {
    handlePageChange(totalPages)
  }, [handlePageChange, totalPages])

  return (
    <div className="paginationContainer">
      <div className="paginationBody">
        <span
          className={`prevPage ${
            activePage <= 1
              ? `disable disable-page-btn`
              : "active"
          } previous-page`}
          onClick={setPrevPage}
        >
          <StaticImage
            src="../../../assets/images/back-arrow.png"
            alt=""
          />
        </span>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={itemsCount}
          pageRangeDisplayed={3}
          totalItemsCount={Math.ceil(Total)}
          onChange={handlePageChange}
          hideNavigation={true}
          hideFirstLastPages={true}
        />
        {activePage === totalPages ||
        activePage === totalPages - 1 ? null : (
          <>
            {totalPages > 3 && (
              <span className="lastPage">
                <span className="pageBlock">...</span>
                <span
                  className="pageBlock"
                  onClick={setLastPage}
                >
                  {totalPages}
                </span>
              </span>
            )}
          </>
        )}
        <span
          className={`nextPage ${
            activePage >= totalPages
              ? `disable disable-page-btn`
              : "active"
          } next-page`}
          onClick={setNextPage}
        >
          <StaticImage
            src="../../../assets/images/forward-arrow.png"
            alt=""
          />
        </span>
      </div>
    </div>
  )
}
export default CustomPagination
